import { render, staticRenderFns } from "./addNotice.vue?vue&type=template&id=4345d464"
import script from "./addNotice.vue?vue&type=script&lang=js"
export * from "./addNotice.vue?vue&type=script&lang=js"
import style0 from "./addNotice.vue?vue&type=style&index=0&id=4345d464&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4345d464')) {
      api.createRecord('4345d464', component.options)
    } else {
      api.reload('4345d464', component.options)
    }
    module.hot.accept("./addNotice.vue?vue&type=template&id=4345d464", function () {
      api.rerender('4345d464', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/productmanager/arrivalNotice/addNotice.vue"
export default component.exports